import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../../assets/logo_classic.png';
import { Box, Link, Button, AppBar, Toolbar } from '@mui/material';

const NavbarMainPage = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ height: '80px', backgroundColor: '#ffffff', boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.16)' }}>
      <Toolbar sx={{ justifyContent: 'space-between', paddingX: 3, height: '100%' }}>
        
        {/* Lewa część: logo */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src={logoImage} alt="Logo" style={{ height: 35 }} />
        </Box>

        {/* Środkowa część: linki */}
        <Box
          sx={{
            display: 'flex',
            gap: 2.5,
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 1,
          }}
        >
          <Link href="#home" underline="none" sx={linkStyle}>
            Strona główna
          </Link>
          <Link href="#about" underline="none" sx={linkStyle}>
            O nas
          </Link>
          <Link href="#price" underline="none" sx={linkStyle}>
            Cennik
          </Link>
          <Link href="#contact" underline="none" sx={linkStyle}>
            Kontakt
          </Link>
        </Box>

        {/* Prawa część: przyciski */}
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'nowrap', flexShrink: 0 }}>
          <Button 
            variant="contained" 
            onClick={() => navigate('/pigeons-login')}
            sx={{
              backgroundColor: '#3A83B0',
              borderRadius: '92px',
              fontSize: '14px',
              fontWeight: 400,
              letterSpacing: '0.42px',
              fontFamily: "'Poppins', sans-serif",
              textTransform: 'none',
              color: 'white',
              minWidth: '120px',
              height: '38px',
              padding: '0 15px',
              boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.16)',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: '#2a6a94',
              },
              '@media (max-width: 1200px)': {
                fontSize: '12px',
                minWidth: '100px',
                height: '35px',
                padding: '0 12px',
              }
            }}
          >
            ZALOGUJ SIĘ
          </Button>
          <Button 
            variant="contained" 
            onClick={() => navigate('/pigeons-register')}
            sx={{
              backgroundColor: '#4FC99D',
              borderRadius: '92px',
              fontSize: '14px',
              fontWeight: 400,
              letterSpacing: '0.42px',
              fontFamily: "'Poppins', sans-serif",
              textTransform: 'none',
              color: 'white',
              minWidth: '120px',
              height: '38px',
              padding: '0 15px',
              boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.16)',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: '#3db889',
              },
              '@media (max-width: 1200px)': {
                fontSize: '12px',
                minWidth: '100px',
                height: '35px',
                padding: '0 12px',
              }
            }}
          >
            STWÓRZ KONTO
          </Button>
        </Box>

      </Toolbar>
    </AppBar>
  );
};

// Styl linków
const linkStyle = {
  fontSize: 18,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  color: '#2A2A2A',
  fontWeight: 400,
  letterSpacing: '0.486px',
  fontFamily: "'Poppins', sans-serif",
  '&:hover': {
    color: 'primary.main',
  },
};

export default NavbarMainPage;
